import React, {PureComponent} from 'react'
import {Switch, Route} from 'react-router-dom'
import {withRouter} from 'react-router'
import CommonRoute from './CommonRoute'
import styled from 'styled-components';

//Pages/Routes
import Header from '../shared/Header';
import Footer from '../shared/Footer';
import Main from '../routes/Main'
import NotFound from '../errors/NotFound'
import ForgotPasswordRoute from '../routes/ForgotPassword';
import CreateRetailerRoute from '../routes/CreateRetailerRoute';
import colors from '../../lib/Colors';

const StyledInnerBody = styled.div`
  min-height: calc(100vh - 60px);
  background: ${colors.almostWhite};
  position: relative;
  padding-bottom: 60px;
`;

const StyledContentWraper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 28px auto;
`;

export class BaseRoutes extends PureComponent {
  constructor(props) {
    super(props)
  }

  componentWillUnmount() {
    if (this.unsubscribeFromHistory) {
      this.unsubscribeFromHistory()
    }
  }

  render() {
    return (
      <StyledInnerBody>
        <Header/>
        <StyledContentWraper>
          <Switch>
            <CommonRoute component={ForgotPasswordRoute} exact={true} path={'/auth/forgot-password'}/>
            <CommonRoute component={CreateRetailerRoute} exact={true} path={'/auth/create-retailer'}/>
            <CommonRoute component={Main} exact={true} path={['/auth/signup', '/auth']}/>
            <Route component={NotFound}/>
          </Switch>
        </StyledContentWraper>
        <Footer/>
      </StyledInnerBody>
    )
  }
}

BaseRoutes.propTypes = {}

BaseRoutes.defaultProps = {}

export default withRouter(BaseRoutes)
